/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { ContainerId } from '../recaptcha.types';

/**
 * Removes the Google reCAPTCHA container element with the specified container ID.
 *
 * @param {ContainerId} containerId - The ID of the container element to be removed.
 * @return {void} This function does not return a value.
 */
export function removeRecaptchaContainer(containerId: ContainerId) {
    const container = document.getElementById(containerId);

    if (!container) {
        return;
    }

    while (container.lastChild) {
        container.lastChild.remove();
    }
}
